import { createLowlight, common } from "lowlight"
// @ts-ignore
import { solidity } from "highlightjs-solidity"

export const lowlight = createLowlight(common)
lowlight.register({ solidity })
